import { Injectable } from '@angular/core';
import { DataEntry } from '@osos/shared/api';
import { TimelinePostPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { TimelinePostV1ParserService } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class TimelinePostFactoryService extends FactoryBase<
  DataEntry,
  TimelinePostPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: TimelinePostV1ParserService,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: TimelinePostPresenterModel): DataEntry {
    throw new Error('Method not implemented.');
  }

  createPresenterModel(model: DataEntry): TimelinePostPresenterModel {
    const parser = this.getParser(
      DataEntry,
      TimelinePostPresenterModel,
      model.specificationVersion,
    );

    const result = parser.getPresenterModel(model);
    return result;
  }
}
